import type { ReactNode } from 'react';
import { profileFormField, profileFormGroups } from './profileFormPresentation';
import { profileObjectValues } from './ProfileObjectFields';
import { profileListValues } from './ProfileListFields';
import { medcallPresentation } from './medcallPresentation';
import { ProfileDocumentView } from './ProfileDocumentView';
import type { ProfileEntity, ProfileField, ProfileRecord } from './types';

const shownValue = (entity: string, field: ProfileField, value: string | null): ReactNode => {
  if (value == null || value === '') return 'Not recorded';
  if (field.type === 'boolean') {
    if (['0', 'false'].includes(value)) return 'No';
    if (['1', 'true'].includes(value)) return 'Yes';
    return <span>Needs review: {value}</span>;
  }
  const parts = entity === 'medcall' ? medcallPresentation.listFields[field.name] : undefined;
  if (parts) {
    const values = profileListValues(value, parts);
    if (!values) return <span>Needs review: {value}</span>;
    if (!values.length) return 'Not recorded';
    return <ul>{values.map((row, index) => <li key={index}>{parts.map(part => row[part.name]).filter(Boolean).join(' ') || 'Needs review'}</li>)}</ul>;
  }
  if (field.objectFields?.length) {
    const values = profileObjectValues(value, field.objectFields);
    if (!values) return <span>Needs review: {value}</span>;
    return <dl className="space-y-1">{field.objectFields.map(part => <div key={part.name}><dt className="text-sm text-muted-foreground">{part.label}</dt><dd>{values[part.name] || 'Not recorded'}</dd></div>)}</dl>;
  }
  return profileFormField(entity, field.name)?.options.find(option => option.value === value)?.label ?? value;
};

export const ProfileRecordValues = ({ entity, record }: { entity: ProfileEntity; record: ProfileRecord }) => <div className="space-y-4">
  {profileFormGroups(entity, false).map(group => <div key={group.label || 'ungrouped'} className="space-y-2">
    {group.label && <h3 className="font-medium">{group.label}</h3>}
    <dl className="grid gap-3 md:grid-cols-3">{group.fields.map(field => <div key={field.name}><dt className="font-medium">{profileFormField(entity.name, field.name)?.label || field.label}</dt><dd className="whitespace-pre-wrap break-words">{entity.name === 'documents' && field.name === 'contents' ? <ProfileDocumentView type={record.values.find(value => value.name === 'TYPE')?.value ?? ''} contents={record.values.find(value => value.name === field.name)?.value ?? null} recordKey={record.key} template={record.values.find(value => value.name === 'template')?.value} /> : shownValue(entity.name, field, record.values.find(value => value.name === field.name)?.value ?? null)}</dd></div>)}</dl>
  </div>)}
</div>;
